
import React, { useEffect, useState } from 'react';
import {
    Button, Card, CardText, CardTitle, Cell, DataTable, Grid, TableBody,

    TableColumn, TableHeader,

    TableRow
} from 'react-md';
import { NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import ApiRequestService from './ApiRequestService';


//Display the list of Edited Categories
const EditedCategoriesTable = ({categories,onCheckboxClick}) => (
    <Card baseId="edited-categories-table" className="md-block-centered" >
        <CardTitle title="Edited Categories"/>
        <CardText>
            <DataTable  indeterminate>
                <TableHeader>
                    <TableRow  onCheckboxClick={onCheckboxClick}>
                    <TableColumn >Subject</TableColumn>
                    <TableColumn>Topic</TableColumn>
                    <TableColumn>Category</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {categories.map((cat, i) => (
                    <TableRow key={i}  onCheckboxClick={onCheckboxClick}>
                        <TableColumn>{cat.subjectName}</TableColumn>
                        <TableColumn>{cat.topicName}</TableColumn>
                        <TableColumn>{cat.categoryName}</TableColumn>
                    </TableRow>
                    ))}
                </TableBody>
            </DataTable>
        </CardText>
    </Card>
  );


const QuestionSync = function(){


    const [progress,setProgress] = useState(false);
    const [showNoSync,setShowNoSync] = useState(false); //When there is nothing to SYnc
    const [editedCats,setEditedCats] = useState([]);
    const [selectedCategories,setSelectedCategories] = useState([]);

    const getEditedCats = async()=>{
        setProgress(true);
        setShowNoSync(false);
        try{
            
            let getCatsResponse = await ApiRequestService({
            method: 'post',
            url:'sync/getCats',
            data: ''
            })
            if(getCatsResponse.data !== undefined && getCatsResponse.data !== null){
                if(getCatsResponse.data.status === 0){
                    if(getCatsResponse.data.data)
                        setEditedCats([...getCatsResponse.data.data])
                    else
                        setShowNoSync(true);
                }else if (getCatsResponse.data.message !== undefined &&  getCatsResponse.data.message !== null ) {
                    NotificationManager.error(getCatsResponse.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Get Edited Categories","Error",5000);
                }
            }else{
                NotificationManager.error("Get Edited Categories","Error",5000);
            }
            
        }catch(err){
           
            NotificationManager.error(err,"Error",5000);
        }finally{
            setProgress(false);
        } 
    }

    const requestQuestionBankSync = async () => {
        setProgress(true);
        try{
            
            let syncResponse = await ApiRequestService({
            method: 'post',
            url:'sync/questions',
            data: selectedCategories
            })
            if(syncResponse.data !== undefined && syncResponse.data !== null){
                if(syncResponse.data.status === 0){
                    NotificationManager.success("Questions Sync Request has been Submitted","Success",5000);
                }else if (syncResponse.data.message !== undefined &&  syncResponse.data.message !== null ) {
                    NotificationManager.error(syncResponse.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Questions Sync Request failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Questions Sync Request failed with Unknown Server Error","Error",5000);
            }
            
        }catch(err){
           
            NotificationManager.error(err,"Error",5000);
        }finally{
            setProgress(false);
            setSelectedCategories([]);
        }    
    }

    useEffect(()=>{
        getEditedCats();
    },[]);
    
    const onCheckboxClick =  (rowIndex, checked, event)=>{
        console.log("rowIndex, checked, event",rowIndex, checked, event);
        if(rowIndex === 0){
            //Select All or None is checked
            if(checked){
                setSelectedCategories([...editedCats]);
            }else{
                setSelectedCategories([]);
            }
        }else{
            if(checked){
                setSelectedCategories([...selectedCategories,editedCats[rowIndex-1]]);
            }else{
                var index = selectedCategories.findIndex((elem)=>{
                    const cat = editedCats[rowIndex-1];
                    return (elem.subjectID ===cat.subjectID) && (elem.topicID ===cat.topicID) && (elem.categoryID ===cat.categoryID) 
                }) 
                setSelectedCategories( [...selectedCategories.slice(0, index), ...selectedCategories.slice(index + 1)]);
            }
        }
    } 

    if(progress){
        return <BeatLoader    loading={progress}  color={'#bb0000'} size={10} />
    }

    return <Grid>
        <Cell style={{width:'100%'}}>
                    <ul className='archive-btn-list'>
                        <li>Select the Categories you want to Sync from the Table below</li> 
                        <li>Click on the below button to push changes in core question bank to stemfluency.</li>
                        <li>Empty subjects, topics, categories and subcategories will not be pushed.</li>
                        <li>You can monitor the status of the operation in the Activity Status table.</li>
                    </ul>
                    {showNoSync?<h4>No Categories to Sync</h4>:<EditedCategoriesTable categories={editedCats} onCheckboxClick={onCheckboxClick}/>}
                    <p></p>
                    <Button disabled={!selectedCategories || selectedCategories.length < 1} className="archive-button" primary raised onClick={requestQuestionBankSync}>Synchronize Question Bank</Button>
                    </Cell>   </Grid>
           
}

export default QuestionSync;
